import { type ClientOnErrorFunction } from "react-router"
import { sentryOnError } from "@sentry/react-router"
import { isIgnoredRouteError } from "source/isIgnoredRouteError"

export const sentryRouterOnError: ClientOnErrorFunction = (error, info) => {
  if (isIgnoredRouteError(error)) return

  sentryOnError(error, info)
}
